var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridButton',{attrs:{"tag-name":_vm.tagName,"href":_vm.href,"target":_vm.target,"type":_vm.type,"button-type":_vm.buttonType,"content":_vm.content},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }